import * as React from "react"
import type { SVGProps } from "react"
const SvgDiamond = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M9.31 17.34q-.33-.15-.58-.44L2.37 9.3A1.6 1.6 0 0 1 2 8.26l.03-.38a1 1 0 0 1 .14-.37l1.55-3.09q.24-.41.62-.66t.86-.25h9.6q.47 0 .86.25.38.25.62.66l1.55 3.1q.1.15.14.36l.03.38a1.7 1.7 0 0 1-.37 1.06l-6.36 7.59a1.7 1.7 0 0 1-1.27.6 2 2 0 0 1-.69-.16m-1.28-9.7h3.94l-1.24-2.48H9.27zm1.14 7.2V9.32H4.56zm1.66 0 4.61-5.53h-4.6zm3-7.2h2.2l-1.25-2.48h-2.2zm-9.86 0h2.2l1.25-2.48h-2.2z" />
  </svg>
)
export default SvgDiamond
